import React, { useState, useEffect } from "react";
import { useConversas } from "../../hooks/admin/ObterConversasETotal";

const AdminConversas: React.FC = () => {
  const [dataInicio, setDataInicio] = useState<string>("");
  const [dataFim, setDataFim] = useState<string>("");
  const [pesquisar, setPesquisar] = useState<boolean>(false);
  const [filtroAvaliacao, setFiltroAvaliacao] = useState<number>(0);

  // Função para converter a data para o formato Unix timestamp
  const convertToUnixTimestamp = (date: string, finalDia: boolean): number => {
    const newDate = new Date(date);
    if (finalDia) {
      newDate.setHours(23, 59, 59, 999);
    }
    return Math.floor(newDate.getTime() / 1000);
  };

  const getDefaultDates = () => {
    const today = new Date();
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(today.getDate() - 15);

    const formatDate = (date: Date) => {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    return {
      dataInicio: formatDate(thirtyDaysAgo),
      dataFim: formatDate(today),
    };
  };

  useEffect(() => {
    const { dataInicio: defaultInicio, dataFim: defaultFim } =
      getDefaultDates();
    setDataInicio(defaultInicio);
    setDataFim(defaultFim);
    setPesquisar(true);
  }, []);

  const { conversas, total, loading, error } = useConversas({
    dataInicio: pesquisar
      ? convertToUnixTimestamp(dataInicio, false)?.toString()
      : undefined,
    dataFim: pesquisar
      ? convertToUnixTimestamp(dataFim, true)?.toString()
      : undefined,
    pesquisar: pesquisar,
    filtroAvaliacao: pesquisar ? filtroAvaliacao : undefined,
  });

  const handlePesquisar = () => {
    setPesquisar(true);
  };

  const handleDataInicioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newDataInicio = e.target.value;
    setPesquisar(false);
    setDataInicio(newDataInicio);

    if (newDataInicio > dataFim) {
      setDataFim(newDataInicio);
    }
  };

  const handleDataFimChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPesquisar(false);
    setDataFim(e.target.value);
  };

  const handleFiltroAvaliacaoChange = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setPesquisar(false);
    setFiltroAvaliacao(parseInt(e.target.value));
  };

  if (loading) {
    return (
      <div className="container mx-auto p-4">
        <div>Carregando...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto p-4">
        <div>{error}</div>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-4">
      {/* <h1 className="text-2xl font-semibold mb-4">Respostas</h1> */}

      <div className="mb-4 flex space-x-4">
        <label>
          Início:
          <input
            type="date"
            value={dataInicio}
            onChange={handleDataInicioChange}
            className="px-4 py-2 border rounded"
          />
        </label>
        <label>
          Fim:
          <input
            type="date"
            value={dataFim}
            onChange={handleDataFimChange}
            className="px-4 py-2 border rounded"
          />
        </label>
        <label>
          Avaliação:
          <select
            value={filtroAvaliacao}
            onChange={handleFiltroAvaliacaoChange}
            className="px-4 py-2 border rounded"
          >
            <option value={0}>Todas</option>
            <option value={1}>Não Ajudou</option>
            <option value={2}>Ajudou</option>
          </select>
        </label>
        <button
          onClick={handlePesquisar}
          className="px-6 py-2 bg-blue-500 text-white rounded hover:bg-blue-700"
        >
          Pesquisar
        </button>
      </div>

      {total.length > 0 && (
        <div className="mb-4">
          {total[0] && (
            <p>
              {total[0]?.avaliacao}: {total[0]?.total}
            </p>
          )}
          {total[1] && (
            <p>
              {total[1]?.avaliacao}: {total[1]?.total}
            </p>
          )}
          {total[2] && (
            <p>
              {total[2]?.avaliacao}: {total[2]?.total}
            </p>
          )}
        </div>
      )}

      <table className="min-w-full table-auto border-collapse">
        <thead>
          <tr className="bg-gray-100">
            <th className="px-6 py-2 text-left">App</th>
            <th className="px-6 py-2 text-left">ID Plus</th>
            <th className="px-6 py-2 text-left">Pergunta</th>
            <th className="px-6 py-2 text-left">Resposta</th>
            <th className="px-6 py-2 text-left">Data de Inclusão</th>
            <th className="px-6 py-2 text-left">Avaliação</th>
          </tr>
        </thead>
        <tbody>
          {conversas.map((conversa) => (
            <tr
              key={conversa.id}
              className={`border-t ${
                conversa.avaliacao === "2"
                  ? "bg-green-200"
                  : conversa.avaliacao === "1"
                  ? "bg-red-200"
                  : ""
              }`}
            >
              <td className="px-6 py-2">{conversa.nome}</td>
              <td className="px-6 py-2">{conversa.id_referencia}</td>
              <td className="px-6 py-2">{conversa.pergunta}</td>
              <td className="px-6 py-2">{conversa.resposta}</td>
              <td className="px-6 py-2">
                {new Date(conversa.inclusao * 1000).toLocaleString("pt-BR", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                })}
              </td>
              <td className="px-6 py-2">
                {conversa.avaliacao === "1"
                  ? "Não ajudou"
                  : conversa.avaliacao === "2"
                  ? "Ajudou"
                  : "Não Avaliado"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminConversas;
